<template>
	<WizardInputFieldLayout title="Command text" description="Appears in the command bar and can be used to search for your tool">
		<template #input>
			<AppTextField v-model="localValue" placeholder="Example: add a customer" outlined />
		</template>
	</WizardInputFieldLayout>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
import WizardInputFieldLayout from '@/components/common/WizardInputFieldLayout.vue';
export default {
	name: 'ToolCommandInputField',
	mixins: [VModelMixin],
	components: { WizardInputFieldLayout },
};
</script>

<style lang="scss" scoped></style>
